'use client';
import Image from 'next/image';
import { FC } from 'react';

import { PUBLIC_IMAGES } from '../../../../config';

import { useMediaEffect } from '@/hooks/useMediaEffect';
import { InstagramPost } from '@/types/types/Home';

export const InstagramContent: FC<{ posts: InstagramPost[] }> = ({ posts }) => {
  const viewPort = useMediaEffect();
  const listLength = {
    lg: 12,
    md: 12,
    sm: 6,
  }?.[viewPort];

  const getPostImageType = (post: InstagramPost, className: string) => {
    if (post.is_video) {
      return <Image className={className} width={27} height={21} alt="feed-icon" src={PUBLIC_IMAGES.INSTAGRAM_VIDEO} />;
    }
    if (post.elements) {
      return (
        <Image className={className} width={24} height={24} alt="feed-icon" src={PUBLIC_IMAGES.INSTAGRAM_COLLECTION} />
      );
    }
    return null;
  };

  return (
    <div className="grid grid-cols-2 grid-rows-3 gap-2 md:grid-cols-3 md:grid-rows-4 md:gap-4 lg:grid-cols-4 lg:grid-rows-3 lg:gap-5	">
      {posts.slice(0, listLength).map((post) => (
        <a
          href={`https://www.instagram.com/p/${post.shortcode}/`}
          target="_blank"
          key={post.shortcode}
          className="relative aspect-square w-full min-w-[150px] overflow-hidden bg-black-400 md:min-w-52 lg:min-w-60"
        >
          {getPostImageType(post, 'z-20	absolute pointer-events-none top-2.5 right-2.5')}
          <div className="z-10 transition-all duration-300 ease-in hover:scale-110">
            <picture className="h-full w-full object-cover">
              <source media="(max-width: 450px)" srcSet={post.image_s} />
              <source media="(max-width: 893px)" srcSet={post.image_m} />
              <source media="(max-width: 1728px)" srcSet={post.image_l} />
              <img
                className="h-full w-full object-cover"
                src={post.thumbnail_src}
                alt={post.edge_media_to_caption}
                loading="lazy"
              />
            </picture>
          </div>
        </a>
      ))}
    </div>
  );
};
